(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('ProvinciaDetailController', ProvinciaDetailController);

    ProvinciaDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Provincia', 'Aeropuerto', 'Region'];

    function ProvinciaDetailController($scope, $rootScope, $stateParams, previousState, entity, Provincia, Aeropuerto, Region) {
        var vm = this;

        vm.provincia = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mVtasWebApp:provinciaUpdate', function(event, result) {
            vm.provincia = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
